import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { $authUserId } from '~/entities/auth';

export const useAuthQuerySync = () => {
    const queryClient = useQueryClient();

    useEffect(() => {
        let previousUserId = $authUserId.getState();

        const subscription = $authUserId.updates.watch((userId) => {
            const leftAuthenticatedPrincipal = previousUserId !== null && previousUserId !== userId;

            previousUserId = userId;

            if (leftAuthenticatedPrincipal) {
                queryClient.clear();
            }
        });

        return () => {
            subscription.unsubscribe();
        };
    }, [queryClient]);
};
